module.exports = __webpack_public_path__ + "img/cover-netsharer.c7ebaa9e.png";